import { render, staticRenderFns } from "./bill-negotiator-bucket.component.vue?vue&type=template&id=126e40b9&"
import script from "./bill-negotiator-bucket.component.vue?vue&type=script&lang=ts&"
export * from "./bill-negotiator-bucket.component.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports